export enum TemplateEditorScreenOption {
  desktop = 'desktop',
  mobile = 'mobile',
}

export class ResponsiveOptions {
  hideOnDesktop: boolean = false;
  hideOnMobile: boolean = false;
}
